import { getScrollTop, getScrollEventTarget, scrollContainerMediaQuery } from '@theme/scroll-container';

class GlassHeaderComponent extends HTMLElement {
  connectedCallback() {
    this.burgerButton = this.querySelector('[ref="burgerButton"]');
    this.mobileMenu = this.querySelector('[ref="mobileMenu"]');

    this._onScroll = this._onScroll.bind(this);
    this._onBurgerClick = this._onBurgerClick.bind(this);
    this._onDocumentClick = this._onDocumentClick.bind(this);
    this._onKeydown = this._onKeydown.bind(this);
    this._bindScrollTarget = this._bindScrollTarget.bind(this);
    this._updateSpacing = this._updateSpacing.bind(this);

    this._bindScrollTarget();
    scrollContainerMediaQuery.addEventListener('change', this._bindScrollTarget);

    if (this.burgerButton) {
      this.burgerButton.addEventListener('click', this._onBurgerClick);
      document.addEventListener('click', this._onDocumentClick);
      document.addEventListener('keydown', this._onKeydown);
    }

    this._updateSpacing();
    this._resizeObserver = new ResizeObserver(this._updateSpacing);
    this._resizeObserver.observe(this);
    window.addEventListener('resize', this._updateSpacing);
  }

  disconnectedCallback() {
    this._scrollTarget?.removeEventListener('scroll', this._onScroll);
    scrollContainerMediaQuery.removeEventListener('change', this._bindScrollTarget);
    if (this.burgerButton) {
      this.burgerButton.removeEventListener('click', this._onBurgerClick);
      document.removeEventListener('click', this._onDocumentClick);
      document.removeEventListener('keydown', this._onKeydown);
    }
    this._resizeObserver?.disconnect();
    window.removeEventListener('resize', this._updateSpacing);
  }

  _updateSpacing() {
    const wrap = this.closest('.glass-header-wrap') ?? this;
    const rect = wrap.getBoundingClientRect();
    const spacing = Math.ceil(rect.bottom + rect.top);
    document.body.style.setProperty('--glass-header-space', `${spacing}px`);
  }

  _bindScrollTarget() {
    this._scrollTarget?.removeEventListener('scroll', this._onScroll);
    this._scrollTarget = getScrollEventTarget();
    this._scrollTarget.addEventListener('scroll', this._onScroll, { passive: true });
    this._onScroll();
  }

  _onScroll() {
    const scrolled = getScrollTop() > 12;
    this.toggleAttribute('data-scrolled', scrolled);
  }

  _onBurgerClick(event) {
    event.stopPropagation();
    const isOpen = this.burgerButton.getAttribute('aria-expanded') === 'true';
    this._setMenuOpen(!isOpen);
  }

  _onDocumentClick(event) {
    if (this.mobileMenu.hasAttribute('hidden')) return;
    if (this.contains(event.target)) return;
    this._setMenuOpen(false);
  }

  _onKeydown(event) {
    if (event.key === 'Escape' && this.burgerButton.getAttribute('aria-expanded') === 'true') {
      this._setMenuOpen(false);
      this.burgerButton.focus();
    }
  }

  _setMenuOpen(open) {
    this.burgerButton.setAttribute('aria-expanded', String(open));
    if (open) {
      this.mobileMenu.removeAttribute('hidden');
      requestAnimationFrame(() => this.mobileMenu.setAttribute('data-open', ''));
    } else {
      this.mobileMenu.removeAttribute('data-open');
      setTimeout(() => {
        if (this.burgerButton.getAttribute('aria-expanded') !== 'true') {
          this.mobileMenu.setAttribute('hidden', '');
        }
      }, 220);
    }
  }
}

if (!customElements.get('glass-header-component')) {
  customElements.define('glass-header-component', GlassHeaderComponent);
}
